import { Directive } from '@angular/core';
import { Nullable } from '@core/helpers/nullable';
import { TuiDay, TuiTime, TuiValueTransformer } from '@taiga-ui/cdk';
import { tuiInputDateTimeOptionsProvider } from '@taiga-ui/kit';

type From = Nullable<[TuiDay, TuiTime | null]>;
type To = Nullable<string>;

/**
 * Преобразовывает дату-время в виде ISO строки в [TuiDay, TuiTime] и обратно.
 */
class IsoStringToDateTimeTransformer extends TuiValueTransformer<From, To> {
  fromControlValue(controlValue: To): From {
    if (!controlValue) return null;

    try {
      const date = new Date(controlValue);

      if (isNaN(date.getTime())) return null;

      return [
        TuiDay.fromLocalNativeDate(date),
        new TuiTime(date.getHours(), date.getMinutes()),
      ];
    } catch {
      return null;
    }
  }

  toControlValue(componentValue: From): To {
    if (!componentValue) return null;

    const [tuiDay, tuiTime] = componentValue;

    if (!tuiDay || !tuiTime) return null;

    const date = tuiDay.toLocalNativeDate();

    date.setHours(tuiTime.hours, tuiTime.minutes, 0, 0);

    return date.toISOString();
  }
}

@Directive({
  selector: 'tui-textfield[xIsoStringTuiDateTimeTransformer]',
  standalone: true,
  providers: [
    tuiInputDateTimeOptionsProvider({
      valueTransformer: new IsoStringToDateTimeTransformer(),
    }),
  ],
})
export class IsoStringTuiDateTimeTransformerDirective {}
